import { LucideIcon } from 'lucide-react';
import { cn } from '@ecom/helper-react-class-combine';
import { Link } from '@/shared/components/primitives/link';
import { useTranslations } from 'next-intl';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';

type CategoryMenuItemProps = {
  label: string;
  icon: LucideIcon;
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
  href: string;
  gtmId: string;
};

export const CategoryMenuItem = ({
  label,
  icon: Icon,
  className,
  iconClassName,
  labelClassName,
  href,
  gtmId,
}: CategoryMenuItemProps) => {
  const t = useTranslations('Home.header.desktopNavMenu');

  return (
    <NavigationMenu.Link asChild>
      <div
        className={cn(
          'group hover:bg-background-subtle relative mb-1 flex w-[160px] cursor-pointer flex-col items-center gap-1.5 rounded-xs px-2 pt-2 pb-4 text-center transition-colors',
          className,
        )}
      >
        <Link
          href={href}
          prefetch
          aria-label={`${t('navigateTo')} ${label}`}
          data-gtm='cta'
          data-cta-name={gtmId}
        >
          <Icon
            className={cn(
              'm-auto mb-2 h-[50px] w-[50px] text-[var(--color-primary)]',
              iconClassName,
            )}
            color='currentColor'
            aria-hidden='true'
          />
          <span
            className={cn('text-m font-body-bold relative font-bold text-white', labelClassName)}
          >
            {label}
            <span className='bg-primary absolute -bottom-1 left-0 h-1 w-full opacity-0 transition-opacity group-hover:opacity-100'></span>
          </span>
        </Link>
      </div>
    </NavigationMenu.Link>
  );
};
